export class SmallBox {
    constructor(
        public id: number = null,
        public title: string,
        public level_id: string,
        public number_of_cards: number,
        public exercises_in_card: number,
        public lesson_id: number,
        public cost: number,
        public files: Array<number>,
        public cost_no_risk: number,
        public reward_no_risk: number,
        public cost_with_risk: number,
        public reward_with_risk: number,
        public penalty_with_risk: number,
        public additional_attempts: number,
        public check_character_id: number = null,
        public risk_character_id: number = null,
        public sell_character_id: number = null,
        public cards_format: string,
        public generated = false
    ) {}
}
